import { FormEvent, ReactNode, useState } from "react";
import { Box, Button, TextField, Typography } from "@mui/material";

type SignInGateProps = {
  children: ReactNode;
};

const authStorageKey = "czinger-configurator-authenticated";

export function SignInGate({ children }: SignInGateProps) {
  const password = process.env.REACT_APP_APP_PASSWORD;
  const [isAuthenticated, setIsAuthenticated] = useState(
    () => !password || sessionStorage.getItem(authStorageKey) === "true",
  );
  const [enteredPassword, setEnteredPassword] = useState("");
  const [hasError, setHasError] = useState(false);

  const signIn = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    if (enteredPassword === password) {
      sessionStorage.setItem(authStorageKey, "true");
      setIsAuthenticated(true);
      setHasError(false);
      return;
    }

    setHasError(true);
    setEnteredPassword("");
  };

  if (isAuthenticated) {
    return <>{children}</>;
  }

  return (
    <Box
      component="main"
      sx={{
        minHeight: "100vh",
        width: "100vw",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        bgcolor: "#111",
        color: "#fff",
        px: 3,
      }}
    >
      <Box
        component="form"
        onSubmit={signIn}
        sx={{
          width: "100%",
          maxWidth: 360,
          display: "flex",
          flexDirection: "column",
          gap: 2,
        }}
      >
        <Typography variant="h5" component="h1">
          Sign in
        </Typography>
        <TextField
          autoFocus
          fullWidth
          label="Password"
          type="password"
          value={enteredPassword}
          error={hasError}
          helperText={hasError ? "Incorrect password" : " "}
          onChange={(event) => {
            setEnteredPassword(event.target.value);
            setHasError(false);
          }}
          slotProps={{
            inputLabel: {
              sx: { color: "rgba(255,255,255,0.72)" },
            },
            input: {
              sx: {
                color: "#fff",
              },
            },
            formHelperText: {
              sx: { color: hasError ? "#ff8a80" : "transparent" },
            },
          }}
          sx={{
            "& .MuiOutlinedInput-root": {
              "& fieldset": { borderColor: "rgba(255,255,255,0.32)" },
              "&:hover fieldset": { borderColor: "rgba(255,255,255,0.56)" },
              "&.Mui-focused fieldset": { borderColor: "#fff" },
            },
          }}
        />
        <Button type="submit" variant="contained" size="large">
          Continue
        </Button>
      </Box>
    </Box>
  );
}
